import { Shield } from "lucide-react";
import { Separator } from "@/components/ui/separator";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <div className="bg-gradient-to-b from-primary/20 to-background py-16">
        <div className="container">
          <div className="max-w-3xl mx-auto text-center space-y-4">
            <Shield className="w-16 h-16 mx-auto text-primary" />
            <h1 className="text-4xl font-bold">Privacy Policy</h1>
            <p className="text-xl text-muted-foreground">
              How we collect, use, and protect your information
            </p>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto space-y-8">
          <section className="space-y-4">
            <h2 className="text-2xl font-semibold">Information We Collect</h2>
            <p className="text-muted-foreground">
              We collect information that you provide directly to us when using our services, including contact information and service requests.
            </p>
          </section>

          <Separator />

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold">How We Use Your Information</h2>
            <p className="text-muted-foreground">
              We use the information we collect to connect you with service providers, improve our services, and communicate with you about your requests.
            </p>
          </section>

          <Separator />

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold">Information Sharing</h2>
            <p className="text-muted-foreground">
              We share your information with service providers only as necessary to fulfill your service requests. We do not sell your personal information to third parties.
            </p>
          </section>

          <Separator />

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold">Data Security</h2>
            <p className="text-muted-foreground">
              We implement appropriate security measures to protect your personal information from unauthorized access, alteration, or disclosure.
            </p>
          </section>

          <Separator />

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold">Your Rights</h2>
            <p className="text-muted-foreground">
              You have the right to access, correct, or delete your personal information. Contact us to exercise these rights.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;